(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chuchi-cart-properties"]) return;
  try {
    
(() => {
  const initial = document.querySelector('[data-chuchi-properties-state]');
  if (!initial) return;
  let running;
  let rerun = false;
  let checkoutPending = false;
  const parse = text => new DOMParser().parseFromString(text, 'text/html').querySelector('[data-chuchi-properties-state]');
  const pendingLine = state => {
    for (const row of state.querySelectorAll('[data-chuchi-property-line]')) {
      const stored = JSON.parse(row.dataset.properties || 'null');
      const properties = Array.isArray(stored) ? Object.fromEntries(stored) : (stored || {});
      const desired = { ...properties };
      if (row.dataset.content) desired.Inhalt = row.dataset.content;
      if (row.dataset.packaging) desired.Verpackungseinheit = row.dataset.packaging;
      if (desired.Inhalt !== properties.Inhalt || desired.Verpackungseinheit !== properties.Verpackungseinheit) {
        return { id: row.dataset.key, quantity: Number(row.dataset.quantity), properties: desired };
      }
    }
  };
  const synchronize = () => {
    if (running) { rerun = true; return running; }
    document.documentElement.classList.add('chuchi-properties-updating');
    running = (async () => {
      let changedCart;
      do {
        rerun = false;
        const url = new URL(initial.dataset.cartUrl, location.origin);
        url.searchParams.set('section_id', 'chuchi-cart-properties');
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Cart properties unavailable');
        let state = parse(await response.text());
        if (!state) throw new Error('Cart properties missing');
        for (let count = 0; count < 250; count++) {
          const change = pendingLine(state);
          if (!change) break;
          const result = await fetch(initial.dataset.changeUrl + '.js', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...change, sections: ['chuchi-cart-properties'], sections_url: initial.dataset.cartUrl })
          });
          if (!result.ok) throw new Error('Cart properties could not be saved');
          changedCart = await result.json();
          state = parse(changedCart.sections?.['chuchi-cart-properties'] || '');
          if (!state) throw new Error('Updated cart properties missing');
        }
        if (pendingLine(state)) throw new Error('Cart properties incomplete');
      } while (rerun);
      if (changedCart && !checkoutPending && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'chuchi-properties', cartData: changedCart });
      }
    })().finally(() => {
      running = undefined;
      document.documentElement.classList.remove('chuchi-properties-updating');
    });
    return running;
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source !== 'chuchi-properties') synchronize().catch(() => {});
    });
  }
  document.addEventListener('submit', async event => {
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    const original = event.target;
    const originalData = new FormData(original);
    const button = event.submitter;
    button.setAttribute('aria-busy', 'true');
    try {
      await synchronize();
      const handoff = document.createElement('form');
      handoff.method = 'post';
      handoff.action = original.action;
      const add = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = value;
        handoff.append(input);
      };
      add('checkout', '');
      for (const [name, value] of originalData) {
        if (name === 'note' || name === 'discount' || name.startsWith('attributes[')) add(name, value);
      }
      document.body.append(handoff);
      handoff.submit();
    } catch {
      let message = original.querySelector('[data-chuchi-properties-error]');
      if (!message) {
        message = document.createElement('p'); message.dataset.chuchiPropertiesError = '';
        message.setAttribute('role', 'alert'); original.append(message);
      }
      message.textContent = initial.dataset.error;
      checkoutPending = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
  synchronize().catch(() => {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuchi-collection-intro"] && !Shopify.designMode) return;
  try {
    
function keepChuchiPreview() {
  if (!document.querySelector('.chuchi-collection')) return;
  for (const id of ['FacetSortForm', 'FacetFiltersForm', 'FacetFiltersFormMobile']) {
    const form = document.getElementById(id);
    if (form && !form.querySelector('input[name="view"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'view';
      input.value = 'chuchi';
      form.append(input);
    }
  }
}
document.addEventListener('DOMContentLoaded', keepChuchiPreview);
document.addEventListener('input', keepChuchiPreview, true);
document.addEventListener('shopify:section:load', keepChuchiPreview);
keepChuchiPreview();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuchi-delivery-state"]) return;
  try {
    
class ChuchiDeliveryCalendar {
  static day(instant = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(instant);
    const value = type => Number(parts.find(part => part.type === type).value);
    return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
  }
  static add(date, days) { return new Date(date.getTime() + days * 86400000); }
  static key(date) { return date.toISOString().slice(0, 10); }
  static easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1));
  }
  static holiday(date, bw = false) {
    const year = date.getUTCFullYear(), key = this.key(date);
    const fixed = ['01-01', '05-01', '10-03', '12-25', '12-26'];
    if (bw) fixed.push('01-06', '11-01');
    if (fixed.includes(key.slice(5))) return true;
    const offsets = bw ? [-2, 1, 39, 50, 60] : [-2, 1, 39, 50];
    return offsets.some(offset => this.key(this.add(this.easter(year), offset)) === key);
  }
  static estimate(cold, instant = new Date()) {
    let ordered = this.day(instant);
    while (ordered.getUTCDay() === 0 || ordered.getUTCDay() === 6 || this.holiday(ordered, true)) ordered = this.add(ordered, 1);
    let dispatch = this.add(ordered, 1);
    while (dispatch.getUTCDay() === 0 || dispatch.getUTCDay() > (cold ? 4 : 5) || this.holiday(dispatch, true)) dispatch = this.add(dispatch, 1);
    const arrivals = [];
    let date = dispatch;
    while (arrivals.length < 2) {
      date = this.add(date, 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !this.holiday(date)) arrivals.push(date);
    }
    return { dispatch, first: arrivals[0], last: arrivals[1] };
  }
}

if (!customElements.get('chuchi-delivery')) {
  let state = document.querySelector('[data-chuchi-cart-state]');
  let pending = false;
  let requestNumber = 0;
  const update = () => document.querySelectorAll('chuchi-delivery').forEach(element => element.render());
  class ChuchiDelivery extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.render()); }
    render() {
      const heading = this.querySelector('[data-delivery-title]');
      if (!heading) return;
      const isProduct = this.dataset.context === 'product';
      const cold = this.dataset.cold === 'true' || (isProduct && state?.dataset.cold === 'true');
      const blocked = this.dataset.blocked === 'true' || (isProduct && state?.dataset.blocked === 'true');
      this.querySelector('[data-delivery-rule]').textContent = cold ? this.dataset.cooled : this.dataset.regular;
      if (blocked || (isProduct && (!state || pending))) {
        heading.textContent = this.dataset.unavailable;
        this.querySelector('[data-delivery-dispatch]').textContent = '';
        this.removeAttribute('data-dispatch-date');
        this.removeAttribute('data-first-date');
        this.removeAttribute('data-last-date');
        return;
      }
      const dates = ChuchiDeliveryCalendar.estimate(cold);
      const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'de', { timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit' });
      heading.textContent = `${this.dataset.title} ${formatter.format(dates.first)} – ${formatter.format(dates.last)}`;
      this.querySelector('[data-delivery-dispatch]').textContent = `${this.dataset.dispatch} ${formatter.format(dates.dispatch)}`;
      this.dataset.dispatchDate = ChuchiDeliveryCalendar.key(dates.dispatch);
      this.dataset.firstDate = ChuchiDeliveryCalendar.key(dates.first);
      this.dataset.lastDate = ChuchiDeliveryCalendar.key(dates.last);
    }
  }
  customElements.define('chuchi-delivery', ChuchiDelivery);
  const refresh = async () => {
    const current = ++requestNumber;
    pending = true;
    update();
    try {
      const url = new URL(state?.dataset.cartUrl || `${window.Shopify.routes.root}cart`, window.location.origin);
      url.searchParams.set('sections', 'chuchi-delivery-state');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Delivery state unavailable');
      const result = await response.json();
      const fresh = new DOMParser().parseFromString(result['chuchi-delivery-state'] || '', 'text/html').querySelector('[data-chuchi-cart-state]');
      if (!fresh) throw new Error('Delivery state missing');
      if (current !== requestNumber) return;
      state = fresh;
      pending = false;
      update();
    } catch {
      if (current === requestNumber) update();
    }
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  setInterval(update, 60000);
  update();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuchi-favorite-brands"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.favorite-directory').forEach(async directory => {
  const input = directory.querySelector('[data-vendor-search]');
  const list = directory.querySelector('.favorite-vendors');
  const empty = directory.querySelector('[data-vendor-empty]');
  const loading = directory.querySelector('[data-vendor-loading]');
  const error = directory.querySelector('[data-vendor-error]');
  const count = directory.querySelector('[data-vendor-count]');
  let entries = [];
  const filter = () => {
    const query = input.value.trim().toLocaleLowerCase('de');
    let visible = 0;
    entries.forEach(entry => {
      entry.hidden = !entry.dataset.vendorName.toLocaleLowerCase('de').includes(query);
      if (!entry.hidden) visible++;
    });
    empty.hidden = visible > 0;
  };
  input.addEventListener('input', filter);
  const getPage = async page => {
    const url = new URL(directory.dataset.vendorSource, location.origin);
    url.searchParams.set('view', 'chuchi-brand-vendors');
    url.searchParams.set('page', page);
    const response = await fetch(url, {cache: 'no-store', credentials: 'same-origin'});
    if (!response.ok) throw new Error('Vendor directory unavailable');
    const data = await response.json();
    if (!Array.isArray(data.vendors) || !Number.isInteger(data.pages)) throw new Error('Invalid vendor directory');
    return data;
  };
  try {
    const first = await getPage(1);
    const vendors = new Set(first.vendors);
    for (let page = 2; page <= first.pages; page++) {
      const result = await getPage(page);
      result.vendors.forEach(vendor => vendors.add(vendor));
    }
    const fragment = document.createDocumentFragment();
    Array.from(vendors).filter(vendor => typeof vendor === 'string' && vendor.trim()).sort((a,b) => a.localeCompare(b, 'de', {sensitivity:'base'})).forEach(vendor => {
      const entry = document.createElement('li');
      entry.dataset.vendorName = vendor;
      const link = document.createElement('a');
      const url = new URL(directory.dataset.vendorSource.replace(/all$/, 'vendors'), location.origin);
      url.searchParams.set('q', vendor);
      url.searchParams.set('sort_by', 'best-selling');
      link.href = url.pathname + url.search;
      link.textContent = vendor;
      entry.append(link);
      fragment.append(entry);
    });
    list.replaceChildren(fragment);
    entries = Array.from(list.children);
    count.textContent = entries.length + ' ' + directory.dataset.vendorCountLabel;
    count.hidden = false;
    input.disabled = false;
    filter();
  } catch {
    error.hidden = false;
  } finally {
    loading.hidden = true;
    list.setAttribute('aria-busy', 'false');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuchi-home-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chuchi-world-slider')) {
  customElements.define('chuchi-world-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.chuchi-world-track');
      this.slides = [...this.querySelectorAll('.chuchi-world-slide')];
      this.topics = [...this.querySelectorAll('.chuchi-world-topic')];
      this.status = this.querySelector('.chuchi-world-status');
      this.index = 0;
      this.querySelector('.chuchi-world-controls').hidden = false;
      this.update(false);
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction))));
      this.topics.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.index))));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const next = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (next !== this.index) {
            this.index = Math.max(0, Math.min(next, this.slides.length - 1));
            this.update(true);
          }
        }, 100);
      }, {passive: true});
      this.resizeObserver = new ResizeObserver(() => this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: 'instant'}));
      this.resizeObserver.observe(this.track);
      this.editorSelect = event => {
        const slide = event.target.closest('.chuchi-world-slide');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.go(index);
      };
      document.addEventListener('shopify:block:select', this.editorSelect);
    }
    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.update(true);
      this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    update(announce) {
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        slide.setAttribute('aria-hidden', String(index !== this.index));
      });
      this.topics.forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      if (announce) this.status.textContent = `${this.index + 1} / ${this.slides.length} · ${this.slides[this.index].dataset.title}`;
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      clearTimeout(this.scrollTimer);
      document.removeEventListener('shopify:block:select', this.editorSelect);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuchi-lazy-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const button = root.querySelector('[data-load-reviews]');
      let loading = false;
      let done = false;
      const load = async () => {
        if (loading || done) return;
        loading = true;
        button.disabled = true;
        button.textContent = button.dataset.loading;
        try {
          const response = await fetch(root.dataset.url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Reviews unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = parsed.querySelector('[id$="__review_loader"]');
          if (!section || !section.querySelector('.jdgm-widget')) throw new Error('Reviews missing');
          const scripts = Array.from(parsed.querySelectorAll('script[src]')).filter(script => {
            const url = new URL(script.src, location.href);
            return url.hostname === 'cdn.shopify.com' && url.pathname.includes('/judgeme-') && !url.pathname.endsWith('/loader.js');
          });
          const initializers = Array.from(section.querySelectorAll('script:not([src])')).filter(script => !script.type || script.type === 'text/javascript');
          section.querySelectorAll('script:not([type="application/json"])').forEach(script => script.remove());
          root.replaceChildren(...Array.from(section.childNodes));
          for (const source of scripts) {
            if (Array.from(document.scripts).some(script => script.src === source.src)) continue;
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = source.src;
              if (source.type) script.type = source.type;
              script.onload = resolve;
              script.onerror = () => { script.remove(); reject(new Error('Review script unavailable')); };
              document.head.appendChild(script);
            });
          }
          for (const source of initializers) {
            const script = document.createElement('script');
            script.textContent = source.textContent;
            root.appendChild(script);
          }
          done = true;
        } catch (error) {
          if (!button.isConnected) root.replaceChildren(button);
          button.disabled = false;
          button.textContent = button.dataset.retry;
        } finally {
          loading = false;
        }
      };
      button.addEventListener('click', load);
      if (window.Shopify && window.Shopify.designMode) load();
      else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '300px' });
        observer.observe(root);
      } else load();
    };
    document.querySelectorAll('[data-chuchi-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-chuchi-reviews]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuchi-main-product"]) return;
  try {
    
if (!customElements.get('chuchi-mobile-purchase')) {
  customElements.define('chuchi-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.sync = () => {
        const source = this.root.querySelector('.chuchi-purchase .product-form__submit');
        const target = this.querySelector('[data-sticky-submit]');
        if (!source || !target) return;
        target.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        const text = source.querySelector('span')?.textContent.trim();
        if (text) target.textContent = target.disabled ? text : target.dataset.readyLabel;
        const priceRoot = this.root.querySelector('[id^="price-"] .price');
        const price = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        if (price) this.querySelector('[data-sticky-price]').textContent = price.textContent.trim();
      };
      this.observer = new MutationObserver(this.sync);
      const info = this.root.querySelector('.product__info-container');
      if (info) this.observer.observe(info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
      this.sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
